import {Translate, I18n} from 'react-redux-i18n';

import OverlayMessageView from '../overlayMessage/OverlayMessageView';

function ErrorOverlay() {
  return (
    <OverlayMessageView
      type="error"
      message={I18n.t('error.generic')}
    >
      <h3><Translate value="errorPage.subtitle"/></h3>
      <div>
        <Translate value="errorPage.text"/>
        <a href={`mailto:${I18n.t('errorPage.contactEmail')}`}>{I18n.t('errorPage.contactEmail')}</a>
      </div>
    </OverlayMessageView>
  );
}

export default ErrorOverlay;
